import { Themes } from "../../theme/theme-schema";

const useTheme = (theme) => {
    return theme ? Themes[theme] : Themes["light"];
};

export default useTheme;